import { IMediaItem } from 'types/media'

export interface ICanvasAabb {
  minX: number
  minY: number
  maxX: number
  maxY: number
}

/**
 * Axis-aligned bounds of `ItemFrame` in logical canvas coordinates.
 * Matches CSS `transform: rotate(θ) scaleX(flip)` with default center origin
 * (scale applied before rotate, right-to-left in the transform list).
 */
export const getMediaItemFrameAabbLogical = (
  item: Pick<IMediaItem, 'coordinates' | 'rotation' | 'flip'>,
  displayWidth: number,
  displayHeight: number
): ICanvasAabb => {
  const { x, y } = item.coordinates
  const w = displayWidth
  const h = displayHeight
  const θ = ((item.rotation ?? 0) * Math.PI) / 180
  const flipX = item.flip?.x ? -1 : 1

  const cx = x + w / 2
  const cy = y + h / 2
  const cos = Math.cos(θ)
  const sin = Math.sin(θ)

  const corners: Array<[number, number]> = [
    [0, 0],
    [w, 0],
    [w, h],
    [0, h]
  ]

  let minX = Infinity
  let minY = Infinity
  let maxX = -Infinity
  let maxY = -Infinity

  for (const [px, py] of corners) {
    let vx = px - w / 2
    const vy = py - h / 2
    vx *= flipX
    const rx = vx * cos + vy * sin
    const ry = -vx * sin + vy * cos
    const wx = cx + rx
    const wy = cy + ry
    minX = Math.min(minX, wx)
    minY = Math.min(minY, wy)
    maxX = Math.max(maxX, wx)
    maxY = Math.max(maxY, wy)
  }

  return { minX, minY, maxX, maxY }
}
